import { ArrowLeft } from "lucide-react";

export const LegalShell = ({ title, children }) => (
  <div className="min-h-screen bg-white text-[#0A0A0A]">
    <header className="border-b border-[#E4E4E7]">
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-5 flex items-center justify-between">
        <a href="/" data-testid="legal-logo" className="flex items-center gap-2.5">
          <img src="/logo-mark-dark.png" alt="SA Webdesign Logo" className="h-8 w-auto" />
          <span className="font-display font-semibold tracking-tight">Webdesign</span>
        </a>
        <a
          href="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#52525B] hover:text-[#2563EB] transition-colors duration-200"
        >
          <ArrowLeft className="w-4 h-4" aria-hidden="true" />
          Zurück zur Startseite
        </a>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20">
      <h1 className="font-display font-medium text-3xl md:text-4xl tracking-tight">{title}</h1>
      <div className="mt-10">{children}</div>
    </main>
    <footer className="border-t border-[#E4E4E7]">
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-xs text-[#A1A1AA]">© {new Date().getFullYear()} SA Webdesign · Stephan Appenzeller</p>
        <div className="flex gap-6 text-xs text-[#A1A1AA]">
          <a href="/impressum" className="hover:text-[#0A0A0A] transition-colors duration-200">Impressum</a>
          <a href="/datenschutz" className="hover:text-[#0A0A0A] transition-colors duration-200">Datenschutz</a>
          <a href="/agb" className="hover:text-[#0A0A0A] transition-colors duration-200">AGB</a>
        </div>
      </div>
    </footer>
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section className="mb-10">
    <h2 className="font-display font-semibold text-lg md:text-xl tracking-tight mb-3">{heading}</h2>
    <div className="text-[15px] text-[#52525B] leading-relaxed space-y-2">{children}</div>
  </section>
);
